import React from 'react';
import Form from '../../components/common/Form';

class FacebookVideoModal extends Form {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let { onClickAway } = this.props;
        return (
            <div id="videoModal" className="modal in" style={{display: "block"}}>
                <div className="modal-content text-center">
                    <iframe
                            src="https://www.youtube.com/embed/MBRqu0YOH14" frameBorder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen></iframe>
                    <button onClick={onClickAway} className='btn-xs'>Close</button>
                </div>
            </div>
        )
    }
}

export default FacebookVideoModal;